import { render, staticRenderFns } from "./LensDashboardReportView.vue?vue&type=template&id=c6564a8a&scoped=true"
import script from "./LensDashboardReportView.vue?vue&type=script&lang=js"
export * from "./LensDashboardReportView.vue?vue&type=script&lang=js"
import style0 from "./LensDashboardReportView.vue?vue&type=style&index=0&id=c6564a8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6564a8a",
  null
  
)

export default component.exports